import { format, parse, isValid, compareAsc } from 'date-fns';
import { format as formatWithTz, zonedTimeToUtc } from 'date-fns-tz';

import { DATE_FORMAT_LONG, DATE_FORMAT_ISO } from '../constants/dateFormat';

interface IParseDate {
  date: string | Date;
  parseFormat: string;
}

interface IFormatDate {
  date: string | Date;
  dateFormat: string;
  parseFormat?: string;
}

interface ICompareDates {
  dateLeft: string | Date;
  dateRigth: string | Date;
  parseFormat?: string;
}

export const parseDate = ({ date, parseFormat }: IParseDate): Date | undefined => {
  if (typeof date === 'number') {
    return undefined;
  }
  const newDate = new Date(date);
  const parsedDate = parse(date instanceof Date ? date.toISOString() : date, parseFormat, new Date());
  if (isValid(newDate) && compareDates({ dateLeft: newDate.toISOString(), dateRigth: date, parseFormat }) === 0) {
    const parsedIsoDate = parse(new Date(date).toISOString(), parseFormat, new Date());
    if (parsedIsoDate.toString() !== 'Invalid Date') {
      return parsedIsoDate;
    }
  }
  if (
    isValid(newDate) &&
    (!isValid(parsedDate) || compareDates({ dateLeft: date, dateRigth: parsedDate.toString(), parseFormat }) === 0)
  ) {
    return newDate;
  }
  if (parsedDate.toString() === 'Invalid Date') {
    return undefined;
  }
  return parsedDate;
};

export const formatDate = ({ date, dateFormat, parseFormat = DATE_FORMAT_LONG }: IFormatDate): string => {
  try {
    if (!date) {
      return '';
    }
    const newDate = parseDate({ date, parseFormat });
    if (newDate) {
      return format(newDate, dateFormat);
    }
    return '';
  } catch {
    return '';
  }
};

export const getFormatedClientTime = (parseFormat = DATE_FORMAT_ISO): string => format(new Date(), parseFormat);

export const formatDateLocale = ({ date, dateFormat, parseFormat = DATE_FORMAT_LONG }: IFormatDate): string => {
  try {
    if (!date) {
      return '';
    }
    const newDate = parseDate({ date, parseFormat });
    if (newDate) {
      return formatWithTz(zonedTimeToUtc(newDate, 'UTC'), dateFormat, { timeZone: 'UTC' });
    }
    return '';
  } catch {
    return '';
  }
};

const convertDateStringToArray = (arr: string): number[] =>
  arr
    .split('.')
    .map(item => Number(item))
    .reverse();

export const compareDates = ({
  dateLeft,
  dateRigth,
  parseFormat = DATE_FORMAT_LONG,
}: ICompareDates): number | false => {
  try {
    if (typeof dateLeft === 'string' && typeof dateRigth === 'string' && dateLeft && dateRigth) {
      const leftDateArr = convertDateStringToArray(dateLeft);
      const rigthDateArr = convertDateStringToArray(dateRigth);

      if (leftDateArr.length === rigthDateArr.length && parseFormat === DATE_FORMAT_LONG) {
        let resultNumber: number | undefined;
        leftDateArr.forEach((item, index) => {
          if (resultNumber === undefined) {
            if (item < rigthDateArr[index]) {
              resultNumber = -1;
            }
            if (item > rigthDateArr[index]) {
              resultNumber = 1;
            }
          }
        });
        if (resultNumber !== undefined) {
          return resultNumber;
        }
      }
    }
    let newDateLeft = new Date(dateLeft);
    let newDateRigth = new Date(dateRigth);
    if (parseFormat && !isValid(newDateLeft)) {
      newDateLeft = parse(dateLeft instanceof Date ? dateLeft.toISOString() : dateLeft, parseFormat, new Date());
    }
    if (parseFormat && !isValid(newDateRigth)) {
      newDateRigth = parse(dateRigth instanceof Date ? dateRigth.toISOString() : dateRigth, parseFormat, new Date());
    }

    return compareAsc(newDateLeft, newDateRigth);
  } catch {
    return false;
  }
};
